import * as MenuPrimitive from '@radix-ui/react-dropdown-menu'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

/**
 * Menú desplegable sobre Radix: el de tres puntos de las tarjetas (P01),
 * el del avatar (C1) y los de administración (P03). Teclado y foco resueltos.
 */
export const MenuDesplegable = MenuPrimitive.Root
export const MenuDisparador = MenuPrimitive.Trigger
export const MenuSeparador = MenuPrimitive.Separator

export function MenuContenido({
  className,
  sideOffset = 6,
  align = 'end',
  ...props
}: ComponentProps<typeof MenuPrimitive.Content>) {
  return (
    <MenuPrimitive.Portal>
      <MenuPrimitive.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(
          'z-50 min-w-48 rounded-2xl border border-borde bg-tarjeta p-1.5 shadow-tarjeta',
          className,
        )}
        {...props}
      />
    </MenuPrimitive.Portal>
  )
}

type MenuItemProps = ComponentProps<typeof MenuPrimitive.Item> & {
  /** Acción destructiva: Dar de baja, Quitar acceso, Desactivar. */
  peligro?: boolean
  /** Texto chico debajo del ítem, p. ej. "Tiene publicaciones asociadas". */
  detalle?: string
}

export function MenuItem({
  className,
  peligro,
  detalle,
  children,
  ...props
}: MenuItemProps) {
  return (
    <MenuPrimitive.Item
      className={cn(
        'flex min-h-11 cursor-default select-none flex-col justify-center rounded-xl px-3 py-2 text-sm outline-none',
        'data-[highlighted]:bg-lienzo',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-40',
        peligro ? 'text-nuevo' : 'text-tinta',
        className,
      )}
      {...props}
    >
      <span className="flex items-center gap-2.5">{children}</span>
      {detalle && <span className="pl-7 text-xs text-tinta-suave">{detalle}</span>}
    </MenuPrimitive.Item>
  )
}
